import React from 'react';
import { Grid, TextField, Box } from '@mui/material';
import { useFormik } from "formik";
import * as yup from "yup";
import styles from './Lab.module.scss'
import { CMButton } from '../Button/Button';
import { buttonStyle } from '../Helpers/InlineStyles';
import { CMLabel } from '../Form/FormLabels';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import 'react-toastify/dist/ReactToastify.css';
import { CMAutoComplete } from '../AutoComplete/AutoComplete';
import { useEffect, useState } from 'react';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { labAddDropdown } from '../../../Pages/Lab/LabServices';
import { nameRegex, numberRegex, numbernamesRegex } from '../Helpers/Validations';


function LabModel(props: any) {
    const ModelBodyComponent = props.modelCmpnt;
    const currentDate = dayjs().format('YYYY-MM-DD');
    const [labTestDropdown, setLabTestDropdown] = useState([]);
    const handleChange = (fields: any, e: any) => {
        formik.setFieldValue(fields, e.target.value);
    }
    const handleDateChange = (fields: any, e: any) => {
        const date = dayjs(e['$d']).format('YYYY-MM-DD')
        formik.setFieldValue(fields, date)
    }
    const [test, setTest] = useState<any>([])
    const handleDropdownChange = (fields: any, e: any) => {
        formik.setFieldValue(fields, e.id)
    }
    useEffect(() => {
        labAddDropdown().then((res: any) => {
                setTest(res);
                setLabTestDropdown(res)
        })

    }, [])
    const formik: any = useFormik({
        initialValues: {
            id: props?.rowData?.id? props?.rowData?.id : "",
            lab_test_name: props?.rowData?.lab_test_name ? props?.rowData?.lab_test_name : "",
            result: props?.rowData?.result ? props?.rowData?.result : "",
            test_date: props?.rowData?.test_date ? props?.rowData?.test_date : currentDate,
            patient_lab_id: props?.rowData?.patient_lab_id ? props?.rowData?.patient_lab_id : ""
        },
        validationSchema: yup.object({
            lab_test_name: yup.string().required(" Tests is required!"),
            result: yup.string().required(" Result is required!"),
            test_date: yup.string().required(" Test Date is required!"),

        }),
        onSubmit: (values: any) => {
            
            if (props?.rowData) {
            console.log(values,"values");
                let totalvalues: any = { ...values }
                props.edit(totalvalues)
            } else {
                let totalvalues: any = { ...values }
                props.onAddRow(totalvalues);
            }
            props?.onHide();
        },
    });

    return (
        <>
            {props?.show &&
                <Modal isOpen={props?.show} onHide={props?.onHide} >
                    <ModalHeader toggle={props.onHide}><h5><b>{props.header}</b></h5></ModalHeader>
                    <ModalBody>
                        <form onSubmit={formik.handleSubmit}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <CMLabel>Test Name</CMLabel>
                                    <CMAutoComplete
                                     options={test}
                                      disabled={false} 
                                      placeholder="Enter Test" name="lab_test_name" 
                                      value={formik.values.lab_test_name || "" }
                                       onChange={(e: any) => handleDropdownChange("lab_test_name", e)} 
                                       errors={formik.touched.lab_test_name && Boolean(formik.errors.lab_test_name)}
                                        helperText={formik.touched.lab_test_name && formik.errors.lab_test_name} />

                                </Grid>

                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <CMLabel>Test Date</CMLabel>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            slotProps={{ textField: { fullWidth: true, size: 'small', name: 'test_date' } }}
                                            format="YYYY-MM-DD"
                                            value={dayjs(formik.values?.test_date)}
                                            onChange={(val: any) => handleDateChange('test_date', val)} />
                                    </LocalizationProvider>
                                    {formik.touched.test_date && formik.errors.test_date && (
                                        <div className={styles.laberrortext + " text-danger"}>{formik.errors.test_date}</div>)
                                    }
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <CMLabel>Result</CMLabel>
                                    <TextField
                                        placeholder='Enter Result'
                                        size="small"
                                        name="result"
                                        multiline
                                        minRows={3}
                                        fullWidth
                                        onChange={(e: any) => handleChange("result", e)}
                                        value={formik.values.result}
                                    />
                                    {formik.touched.result && formik.errors.result && (
                                        <div className={styles.laberrortext + " text-danger"}>{formik.errors.result}</div>)
                                    }
                                </Grid>
                            </Grid>
                            <Box component='div'
                                sx={buttonStyle}>
                                <Box component='span'>
                                    <CMButton variant="contained" value="Submit" type="submit" color="primary" />
                                </Box>
                            </Box>
                        </form>
                    </ModalBody>
                </Modal>
            }
        </>
    );
}

export default LabModel;